import cn from 'clsx';
import { UIText1, UIHeading1, useDeviceType } from '@cian/ui-kit';

import styles from './styles.css';

export interface ICommunicationLayoutProps {
  image?: React.ReactElement;
  title: string | React.ReactElement;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  message?: string | React.ReactNode;
  testId?: string;
  textAlign?: 'center' | 'left';
  maxWidth?: string;
}

export const CommunicationLayout: React.FC<ICommunicationLayoutProps> = props => {
  const deviceType = useDeviceType();
  const { image, title, message, actions, children, testId, maxWidth, textAlign = 'center' } = props;

  return (
    <div className={cn(styles['root'], styles[deviceType])} style={{ maxWidth }} data-testid={testId}>
      <div className={cn(styles['content-wrapper'], styles[deviceType])}>
        {image && <div className={cn(styles['image-area'], styles[deviceType])}>{image}</div>}
        <div className={styles['title-area']}>
          <UIHeading1 data-testid="communication-title" textAlign={textAlign}>
            {title}
          </UIHeading1>
        </div>
        {message && (
          <div className={styles['message-area']}>
            <UIText1 data-testid="communication-message" textAlign={textAlign}>
              {message}
            </UIText1>
          </div>
        )}

        {children && <div className={styles['content-area']}>{children}</div>}
      </div>
      {actions && <div className={cn(styles['actions-area'], styles[deviceType])}>{actions}</div>}
    </div>
  );
};

CommunicationLayout.displayName = 'CommunicationLayout';
